export const delay = (ms = 1000) => {
    return new Promise<boolean>((res, rej) => {
        setTimeout(() => {
            res(true);
        }, ms);

    });
}